const TypeOfProperty = [
  {
    name: "Acreage/Semi-Rural",
    title: "Acreage/Semi-Rural",
  },
  {
    name: "Alpine",
    title: "Alpine",
  },
  {
    name: "Apartment",
    title: "Apartment",
  },
  {
    name: "Block Of Units",
    title: "Block Of Units",
  },
  {
    name: "Duplex/Semi-detached",
    title: "Duplex/Semi-detached",
  },
  {
    name: "Flat",
    title: "Flat",
  },
  {
    name: "House",
    title: "House",
    // isChecked: true,
  },
  {
    name: "Retirement Living",
    title: "Retirement Living",
  },
  {
    name: "Serviced Apartment",
    title: "Serviced Apartment",
  },
  {
    name: "Studio",
    title: "Studio",
  },
  {
    name: "Terrace",
    title: "Terrace",
  },
  {
    name: "Townhouse",
    title: "Townhouse",
  },
  {
    name: "Unit",
    title: "Unit",
  },
  {
    name: "Villa",
    title: "Villa",
  },
  {
    name: "Warehouse",
    title: "Warehouse",
  },
  {
    name: "Other",
    title: "Other",
  },
 
  
];

const Bedrooms = [
  {
    name: "any",
    title: "Any",
  },
  {
    name: "studio",
    title: "Studio",
  },
  {
    name: "1",
    title: "1",
  },
  {
    name: "2",
    title: "2",
  },
  {
    name: "3",
    title: "3",
  },
  {
    name: "4",
    title: "4",
  },
  {
    name: "5",
    title: "5",
  },
];

const Bathrooms = [
  {
    name: "any",
    title: "Any",
  },
  {
    name: "+1",
    title: "+1",
  },
  {
    name: "+2",
    title: "+2",
  },
  {
    name: "+3",
    title: "+3",
  },
  {
    name: "+4",
    title: "+4",
  },
  {
    name: "+5",
    title: "+5",
  },
];

const CarSpaces = [
  {
    name: "any",
    title: "Any",
  },
  {
    name: "+1",
    title: "+1",
  },
  {
    name: "+2",
    title: "+2",
  },
  {
    name: "+3",
    title: "+3",
  },
  {
    name: "+4",
    title: "+4",
  },
  {
    name: "+5",
    title: "+5",
  },
];

const OutdoorFeatures = [
  {
    name: "outdoor_deck",
    title: "Deck",
  },
  {
    name: "outdoor_swimming_pool_in_ground",
    title: "Swimming Pool - In Ground",
  },
  {
    name: "outdoor_swimming_pool_above_ground",
    title: "Swimming Pool - Above Ground",
  },
  {
    name: "outdoor_tennis_court",
    title: "Tennis Court",
  },
  {
    name: "outdoor_fully_fenced",
    title: "Fully Fenced",
  },
  {
    name: "outdoor_shed",
    title: "Shed",
  },
  {
    name: "outdoor_outside_spa",
    title: "Outside Spa",
  },
  {
    name: "outdoor_outdoor_entertainment_area",
    title: "Outdoor Entertainment Area",
  },
  {
    name: "outdoor_secure_parking",
    title: "Secure Parking",
  },
  {
    name: "outdoor_courtyard",
    title: "Courtyard",
  },
  {
    name: "outdoor_remote_garage",
    title: "Remote Garage",
  },
  {
    name: "outdoor_garage",
    title: "Garage",
  },
  {
    name: "outdoor_balcony",
    title: "Balcony",
  },
];

const IndoorFeatures = [
  {
    name: "indoor_alaram_system",
    title: "Alaram System",
  },
  {
    name: "indoor_study",
    title: "Study",
  },
  {
    name: "indoor_workshop",
    title: "Workshop",
  },
  {
    name: "indoor_gym",
    title: "Gym",
  },
  {
    name: "indoor_built_in_wardrodes",
    title: "Built-in Wardrodes",
  },
  {
    name: "indoor_intercom",
    title: "Intercom",
  },
  {
    name: "indoor_ducted_vacuum_system",
    title: "Ducted Vacuum System",
  },
  {
    name: "indoor_rumpus_room",
    title: "Rumpus Room",
  },
  {
    name: "indoor_inside_spa",
    title: "Inside Spa",
  },
  {
    name: "indoor_floorboards",
    title: "Floorboards",
  },
  {
    name: "indoor_dishwashera",
    title: "Dishwashera",
  },
  {
    name: "indoor_play_tv_access",
    title: "Play TV Access",
  },
  {
    name: "indoor_broadband_internet_available",
    title: "Broadband Internet Available",
  },
];

const ClimateChangerAndEnergySaver = [
  {
    name: "cces_air_conditionings",
    title: "Air Conditioning",
  },
  {
    name: "cces_solar_hot_water",
    title: "Solar Hot Water",
  },
  {
    name: "cces_high_energy_efficieny",
    title: "High Energy Efficieny",
  },
  {
    name: "cces_solar_panels",
    title: "Solar panels",
  },
  {
    name: "cces_heating",
    title: "Heating",
  },
  {
    name: "cces_water_tank",
    title: "Water Tank",
  },
];

const NewOrEstablished = [
  {
    name: "established_property",
    title: "Established property",
  },
  {
    name: "new_construction",
    title: "New construction",
  },
];

const MethodOfSale = [
  {
    name: "all_types",
    title: "All Types",
  },
  {
    name: "private_treaty_sale",
    title: "Private treaty sale",
  },
  {
    name: "auction",
    title: "Auction",
  },
];

const PropertyRequirements = [
  {
    name: "furnished",
    title: "Furnished",
  },
  {
    name: "pets_considered",
    title: "Pets Considered",
  },
];

const AvailableDate = [
  {
    tag: "Before",
    date: "16",
    day: "Sunday",
    month: "oct",
  },
  {
    tag: "Before",
    date: "17",
    day: "Monday",
    month: "oct",
  },
  {
    tag: "Before",
    date: "18",
    day: "Tuesday",
    month: "oct",
  },
  {
    tag: "Before",
    date: "19",
    day: "Wednesday",
    month: "oct",
  },
  {
    tag: "Before",
    date: "20",
    day: "Thursday",
    month: "oct",
  },
  {
    tag: "Before",
    date: "20",
    day: "Thursday",
    month: "oct",
  },
];

export {
  TypeOfProperty,
  Bedrooms,
  Bathrooms,
  CarSpaces,
  OutdoorFeatures,
  IndoorFeatures,
  ClimateChangerAndEnergySaver,
  NewOrEstablished,
  MethodOfSale,
  PropertyRequirements,
  AvailableDate,
};
